import types from "./actionTypes"
import { union, filter } from "lodash"

const initialState = {
  keyword: null,
  searchResult: [],
  isLoading: false,
  displayItem: null,
  isLoadingDetail: false,

  // History
  isLoadingHistory: false,
  historyData: [],

  // Privilege
  isLoadingPrivilege: false,
  privilegeData: [],
  useResult: null,

  // Privilege Detail
  isLoadingPrivilegeDetail: false,
  privilegeDetailData: {},

  // Claim Privilege
  gettingCodeId: [],
  activeCodes: [],
  confirmLoadingCodeIds: [],

  // Activiate
  isCardActivateLoading: false,
  isCardActivateComplete: false,
}

export default function search(state = initialState, action) {
  switch (action.type) {
    case types.SEARCH_USER:
      return {
        ...state,
        isLoading: true,
        keyword: action.data,
        displayItem: null,
      }
    case types.SEARCH_USER_COMPLETE:
      return {
        ...state,
        isLoading: false,
        searchResult: action.data,
        displayItem: null,
      }
    case types.SEARCH_GET_MEMBER:
      return {
        ...state,
        isLoadingDetail: true,
        displayItem: null,
      }
    case types.SEARCH_GET_MEMBER_COMPLETE:
      return {
        ...state,
        isLoadingDetail: false,
        displayItem: action.data,
      }

    case types.SHOW_RESULT:
      return {
        ...state,
        isLoadingDetail: false,
        displayItem: action.data,
      }
    case types.LOAD_HISTORY:
      return {
        ...state,
        isLoadingHistory: true,
      }
    case types.LOAD_HISTORY_COMPLETE:
      return {
        ...state,
        isLoadingHistory: false,
        historyData: action.data,
      }
    case types.LOAD_PRIVILEGE:
      if (action.silent) {
        return state
      }

      return {
        ...state,
        isLoadingPrivilege: true,
        privilegeData: [],
      }
    case types.LOAD_PRIVILEGE_COMPLETE:
      return {
        ...state,
        isLoadingPrivilege: false,
        privilegeData: action.data.privilege,
        activeCodes: action.data.activeCode,
      }
    case types.LOAD_PRIVILEGE_DETAIL:
      return {
        ...state,
        isLoadingPrivilegeDetail: true,
        privilegeDetailData: {},
      }
    case types.LOAD_PRIVILEGE_DETAIL_COMPLETE:
      return {
        ...state,
        isLoadingPrivilegeDetail: false,
        privilegeDetailData: action.data,
      }
    case types.USE_PRIVILEGE:
      return {
        ...state,
        gettingCodeId: union(state.gettingCodeId, [action.data.id]),
      }
    case types.USE_PRIVILEGE_ERROR:
      return {
        ...state,
        gettingCodeId: filter(
          state.gettingCodeId,
          (obj) => obj !== action.data
        ),
      }
    case types.USE_PRIVILEGE_COMPLETE:
      const pid = action.data[0].pid
      return {
        ...state,
        gettingCodeId: filter(state.gettingCodeId, (obj) => obj !== pid),
        activeCodes: union(state.activeCodes, action.data),
      }

    case types.CONFIRM_PRIVILEGE_USE:
      return {
        ...state,
        confirmLoadingCodeIds: union(state.confirmLoadingCodeIds, [
          action.data.pid,
        ]),
      }
    case types.CONFIRM_PRIVILEGE_USE_FAIL:
      return {
        ...state,
        confirmLoadingCodeIds: filter(
          state.confirmLoadingCodeIds,
          (obj) => obj !== action.data
        ),
      }
    case types.CONFIRM_PRIVILEGE_USE_COMPLETE:
      return {
        ...state,
        confirmLoadingCodeIds: filter(
          state.confirmLoadingCodeIds,
          (obj) => obj !== action.data
        ),
        activeCodes: filter(
          state.activeCodes,
          (obj) => obj.pid !== action.data
        ),
      }

    case types.USE_PRIVILEGE_EXPIRE:
      return {
        ...state,
        activeCodes: filter(
          state.activeCodes,
          (obj) => obj.objId !== action.idx
        ),
      }
    case types.ACTIVATE_CARD:
      return {
        ...state,
        isCardActivateComplete: false,
        isCardActivateLoading: true,
      }
    case types.ACTIVATE_CARD_COMPLETE:
      return {
        ...state,
        isCardActivateLoading: false,
        isCardActivateComplete: true,
      }
    case types.ACTIVATE_FAIL:
      return {
        ...state,
        isCardActivateLoading: false,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/Search/store/reducers.js